<!-- src/app/pages/contact/contact.component.html -->
<section class="contact-page">

  <!-- HERO -->
  <div class="contact-hero">
    <div class="contact-eyebrow">Get in Touch</div>
    <h1>Connect with Lydia</h1>
    <p>Michigan's Unchained Voice wants to hear from you. Share your thoughts, ask questions, or join the campaign.</p>
  </div>

  <!-- BODY -->
  <div class="contact-body">
    <div class="container">
      <div class="contact-grid">

        <!-- FORM -->
        <div class="contact-form-wrap">
          <h2>Send a Message</h2>

          <form #contactForm="ngForm" (ngSubmit)="onSubmit()" *ngIf="!submitted" id="contact-form">
            <div class="form-group">
              <label for="contact-name">Full Name</label>
              <input
                id="contact-name"
                type="text"
                placeholder="Your full name"
                required
                [(ngModel)]="contact.name"
                name="name"
                #name="ngModel"
                aria-required="true"
                aria-describedby="name-error"
                [disabled]="isSubmitting"
              />
              <div *ngIf="name.invalid && name.touched" class="error" id="name-error">
                Full name is required.
              </div>
            </div>

            <div class="form-group">
              <label for="contact-email">Email Address</label>
              <input
                id="contact-email"
                type="email"
                placeholder="your@email.com"
                required
                [(ngModel)]="contact.email"
                name="email"
                #email="ngModel"
                aria-required="true"
                aria-describedby="email-error"
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                [disabled]="isSubmitting"
              />
              <div *ngIf="email.invalid && email.touched" class="error" id="email-error">
                <span *ngIf="email.errors?.['required']">Email is required.</span>
                <span *ngIf="email.errors?.['pattern']">Please enter a valid email address.</span>
              </div>
            </div>

            <div class="form-group">
              <label for="contact-message">Your Message</label>
              <textarea
                id="contact-message"
                placeholder="What's on your mind?"
                required
                [(ngModel)]="contact.message"
                name="message"
                #message="ngModel"
                aria-required="true"
                aria-describedby="message-error"
                minlength="10"
                [disabled]="isSubmitting"
              ></textarea>
              <div *ngIf="message.invalid && message.touched" class="error" id="message-error">
                <span *ngIf="message.errors?.['required']">Message is required.</span>
                <span *ngIf="message.errors?.['minlength']">Message must be at least 10 characters.</span>
              </div>
            </div>

            <button
              type="submit"
              [disabled]="contactForm.invalid || isSubmitting"
              aria-label="Send message to Lydia's campaign"
            >
              {{ isSubmitting ? 'Sending...' : 'Send Message' }}
            </button>
            <div *ngIf="errorMessage" class="error" id="submit-error">{{ errorMessage }}</div>
          </form>

          <div *ngIf="submitted" class="success-message">
            <div class="success-message__icon">✓</div>
            <h3>Message Sent!</h3>
            <p>Thank you for reaching out. We will get back to you soon.</p>
            <button type="button" (click)="resetForm()" aria-label="Send another message">
              Send Another Message
            </button>
          </div>
        </div>

        <!-- SIDEBAR -->
        <aside class="contact-sidebar">

          <div class="contact-info-card">
            <div class="contact-info-card__icon">✉</div>
            <div class="contact-info-card__label">Email</div>
            <a href="mailto:senator@lydialynnchristensen.com" class="contact-info-card__value">
              senator&#64;lydialynnchristensen.com
            </a>
          </div>

          <div class="contact-info-card">
            <div class="contact-info-card__icon">📮</div>
            <div class="contact-info-card__label">Mail</div>
            <div class="contact-info-card__value">
              PO Box 207<br>Ironwood, MI 49938
            </div>
          </div>

          <div class="contact-info-card">
            <div class="contact-info-card__icon">💬</div>
            <div class="contact-info-card__label">Discord Community</div>
            <a href="https://discord.gg/DNqwMBsycY" target="_blank" rel="noopener noreferrer" class="contact-info-card__value">
              discord.gg/DNqwMBsycY
            </a>
          </div>

          <div class="contact-social">
            <div class="contact-social__label">Follow the Campaign</div>
            <div class="contact-social__links">
              <a href="https://www.facebook.com/profile.php?id=61574235554571" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <svg viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                Facebook
              </a>
              <a href="https://www.tiktok.com/@lydiaforussenate" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3z"/></svg>
                TikTok
              </a>
              <a href="https://bsky.app/profile/lydiaforussenate.bsky.social" target="_blank" rel="noopener noreferrer" aria-label="Bluesky">
                <img src="https://upload.wikimedia.org/wikipedia/commons/7/7a/Bluesky_Logo.svg" alt="Bluesky" width="16" height="16" />
                Bluesky
              </a>
              <a href="https://discord.gg/DNqwMBsycY" target="_blank" rel="noopener noreferrer" aria-label="Discord">
                <svg viewBox="0 0 24 24"><path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03z"/></svg>
                Discord
              </a>
            </div>
          </div>

          <div class="contact-cta-card">
            <div class="contact-cta-card__title">Want to make a bigger impact?</div>
            <p>Become a Constitutional Captain and help collect petition signatures across Michigan.</p>
            <a routerLink="/volunteer">Become a Captain</a>
          </div>

        </aside>
      </div>
    </div>
  </div>

</section>
